import { GameConstants } from "./../../../GameConstants";
import { GameVars } from "./../../../GameVars";
import { TopInfo } from "./TopInfo";

export class HUD extends Phaser.GameObjects.Container {

    private wins: Phaser.GameObjects.Text[];
    private points: Phaser.GameObjects.Text[];
    private ids: string[];

    private topInfo: TopInfo;

    constructor(scene: Phaser.Scene) {

        super(scene);

        if (GameConstants.AI_MODE) {
            this.createInfoAI();
            this.updateInfoAI();
        }

        this.topInfo = new TopInfo(this.scene);
        this.add(this.topInfo);  
    }

    public updateInfo(): void {

        this.topInfo.updateInfo();
    }

    public updateInfoAI(): void {

        for (let i = 0; i < this.wins.length; i++) {

            this.wins[i].setText(GameVars.winners[this.ids[i]].toString());
            this.points[i].setText(GameVars.points[this.ids[i]].toString());
        }
    }

    public updatePot(): void {

        this.topInfo.updatePot();
    }

    private createInfoAI(): void {

        let text = new Phaser.GameObjects.Text(this.scene, 200, GameConstants.GAME_HEIGHT - 50, "POINTS", {fontFamily: "Oswald-Medium", fontSize: "20px", color: "#000000"});
        text.setOrigin(.5);
        this.add(text);

        text = new Phaser.GameObjects.Text(this.scene, 200, GameConstants.GAME_HEIGHT - 20, "WINS", {fontFamily: "Oswald-Medium", fontSize: "20px", color: "#000000"});
        text.setOrigin(.5);
        this.add(text);

        this.wins = [];
        this.points = [];
        this.ids = [];

        let players = Object.keys(GameVars.winners);

        for (let i = 0; i < players.length; i++) {

            this.ids.push(players[i]);

            text = new Phaser.GameObjects.Text(this.scene, 320 + 120 * i, GameConstants.GAME_HEIGHT - 80, players[i].toUpperCase(), {fontFamily: "Oswald-Medium", fontSize: "18px", color: "#000000"});
            text.setOrigin(.5);
            this.add(text);

            let win = new Phaser.GameObjects.Text(this.scene, 320 + 120 * i, GameConstants.GAME_HEIGHT - 20, "0", {fontFamily: "Oswald-Medium", fontSize: "18px", color: "#000000"});
            win.setOrigin(.5);
            this.add(win);

            this.wins.push(win);

            let point = new Phaser.GameObjects.Text(this.scene, 320 + 120 * i, GameConstants.GAME_HEIGHT - 50, "0", {fontFamily: "Oswald-Medium", fontSize: "18px", color: "#000000"});
            point.setOrigin(.5);
            this.add(point);

            this.points.push(point);
        }

        let graphics = new Phaser.GameObjects.Graphics(this.scene);
        graphics.x = -60;
        graphics.y = GameConstants.GAME_HEIGHT - 95;
        graphics.lineStyle(4, 0x000000, 1);

        for (let i = 0; i < GameVars.gameState.players.length; i++) {
            for (let j = 0; j < 3; j++) {
                graphics.strokeRect(200 + 120 * i, 30 * j, 120, 30);
            }
        }

        this.add(graphics);
    }
}
